import { Tabs } from "@shared/ui/tabs";
import { Edit3, FileText } from "lucide-react";
import { SingleBillDraft } from "./singleBillDraft";
import { SingleBillTable } from "./singleBillTable";

export const SingleBillTab = () => {
  // Define subtab components
  const singleBillSubTabs = {
    "all-bills": {
      label: "All Bills",
      icon: <FileText className="h-4 w-4" />,
      component: <SingleBillTable />,
    },
    "draft-bills": {
      label: "Draft Bills",
      icon: <Edit3 className="h-4 w-4" />,
      component: <SingleBillDraft />,
    },
  };

  return (
    <div className="space-y-4">
      {/* Subtabs for All Bills and Draft Bills */}
      <Tabs
        tabComponents={singleBillSubTabs}
        defaultValue="all-bills"
        urlMapping={{
          "all-bills": "all",
          "draft-bills": "draft",
        }}
        tabsListClassName="w-fit grid grid-cols-2 bg-muted/30 p-1"
        idPrefix="single-bill-subtab"
        level={1} // Set level to 1 for subtabs
      />
    </div>
  );
};
